import { BlogIndexPage } from 'components/blog/blog-index-page';
import { BlogWrapper } from 'components/blog/blog-wrapper';
import { fetchTaggedArticles } from 'queries';

const NewsRoute = ({ ssr, router, session, store, toast }) => {
	// Render
	return <BlogIndexPage title='News' ssr={ssr} />;
};

NewsRoute.getLayout = (page, ssr) => {
	const tag = ssr.tag?.data || {};
	return <BlogWrapper seo={{ description: tag.description }}>{page}</BlogWrapper>;
};

export async function getServerSideProps(props) {
	const articles = await fetchTaggedArticles('news', props);
	return { props: { articles } };
}

export default NewsRoute;
